import { useTranslations } from '@vocab/react';
import { Box, Columns, Column, Divider, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const SocialDivider = () => {
  const { t } = useTranslations(translations);
  return (
    <Box paddingBottom="large" paddingTop="large">
      <Columns space="small" alignY="center">
        <Column>
          <Divider />
        </Column>
        <Column width="content">
          <Text tone="secondary" align="center">
            {t('or')}
          </Text>
        </Column>
        <Column>
          <Divider />
        </Column>
      </Columns>
    </Box>
  );
};
